import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ClerkProvider } from "@clerk/clerk-react";
import * as Sentry from "@sentry/react";
import { App } from "./App";
import { DEV_AUTH_ENABLED } from "./lib/devAuth";
import "./styles/globals.css";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({ dsn: sentryDsn, environment: import.meta.env.MODE });
}

const clerkKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!DEV_AUTH_ENABLED && !clerkKey) {
  console.error("VITE_CLERK_PUBLISHABLE_KEY is not set");
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 15_000 },
  },
});

function Root({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>{children}</BrowserRouter>
    </QueryClientProvider>
  );
}

const tree = DEV_AUTH_ENABLED ? (
  <Root>
    <App />
  </Root>
) : (
  <ClerkProvider publishableKey={clerkKey ?? ""} afterSignOutUrl="/sign-in">
    <Root>
      <App />
    </Root>
  </ClerkProvider>
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>{tree}</React.StrictMode>,
);
